import { ArrowUpRight, Menu, X } from "lucide-react";
import { useState } from "react";

const Navbar = ({ settings }) => {
  const [open, setOpen] = useState(false);
  const phone = settings.phone.replace(/[^0-9+]/g, "");

  return (
    <header className="site-nav" data-testid="site-header">
      <div className="nav-inner">
        <a className="brand-lockup" href="#top" data-testid="navbar-brand-logo">
          <img src={settings.logo_url} alt={`${settings.company_name} logo`} />
          <span>{settings.company_name}</span>
        </a>
        <nav className={open ? "nav-links is-open" : "nav-links"} aria-label="Primary navigation">
          <a href="#craft" onClick={() => setOpen(false)} data-testid="navbar-craft-link">Services</a>
          <a href="#work" onClick={() => setOpen(false)} data-testid="navbar-work-link">Our work</a>
          <a href="#coverage" onClick={() => setOpen(false)} data-testid="navbar-coverage-link">Areas</a>
          <a className="mobile-admin-link" href="/admin" data-testid="navbar-mobile-admin-link">Private admin</a>
        </nav>
        <div className="nav-actions">
          <a className="nav-phone" href={`tel:${phone}`} data-testid="navbar-phone-cta"><span>Call</span> {settings.phone}</a>
          <a className="nav-admin" href="/admin" data-testid="navbar-admin-trigger">Admin <ArrowUpRight size={15} /></a>
        </div>
        <button className="menu-toggle" type="button" onClick={() => setOpen(!open)} aria-label={open ? "Close navigation" : "Open navigation"} data-testid="navbar-menu-toggle">
          {open ? <X size={21} /> : <Menu size={21} />}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
